import React from 'react';

const TrulyInboxIcon = ({ width = 64, height = 64 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32Z"
      fill="url(#paint0_linear_6944_704199)"
    />
    <path
      d="M40.1529 21.336C40.0752 21.1803 39.9532 21.051 39.8022 20.9648C39.6511 20.8785 39.478 20.8389 39.3044 20.8511H24.6983C24.5247 20.8389 24.3515 20.8785 24.2005 20.9648C24.0495 21.051 23.9275 21.1803 23.8498 21.336L18.7287 33.3363C18.6941 33.4442 18.6736 33.5562 18.668 33.6696V40.3667C18.6756 40.9965 18.9377 41.5962 19.394 42.0299C19.8506 42.4635 20.4631 42.6945 21.0922 42.6698H42.9104C43.5395 42.6944 44.1521 42.4635 44.6086 42.0299C45.0649 41.5962 45.327 40.9965 45.3346 40.3667V33.6696C45.3292 33.5463 45.3089 33.4243 45.2739 33.306L40.1529 21.336ZM36.0619 32.9725C35.8564 32.9594 35.6525 33.0191 35.4864 33.1409C35.3202 33.2627 35.2022 33.4392 35.1529 33.6393C35.1226 33.7302 34.6074 36.2454 32.0013 36.2454C29.3951 36.2454 28.9104 33.9121 28.8497 33.6393C28.8004 33.4392 28.6823 33.2627 28.5162 33.1409C28.35 33.0191 28.1462 32.9594 27.9407 32.9725H20.9105L25.2743 22.6692H38.7286L43.0924 32.9725H36.0619Z"
      fill="white"
    />
    <path
      d="M28.0303 26.6089H35.9694C36.2943 26.6089 36.5944 26.4358 36.7568 26.1545C36.9192 25.8731 36.9192 25.5266 36.7568 25.2455C36.5944 24.9642 36.2943 24.7908 35.9694 24.7908H28.0303C27.7055 24.7908 27.4053 24.9642 27.2429 25.2455C27.0805 25.5266 27.0805 25.8731 27.2429 26.1545C27.4053 26.4358 27.7055 26.6089 28.0303 26.6089Z"
      fill="white"
    />
    <path
      d="M37.1828 28.7302H26.8191C26.4943 28.7302 26.1942 28.9036 26.032 29.1849C25.8696 29.4662 25.8696 29.8126 26.032 30.0939C26.1942 30.3752 26.4943 30.5486 26.8191 30.5486H37.1828C37.5076 30.5486 37.8078 30.3752 37.97 30.0939C38.1324 29.8126 38.1324 29.4662 37.97 29.1849C37.8078 28.9036 37.5077 28.7302 37.1828 28.7302Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_6944_704199"
        x1="32"
        y1="0"
        x2="32"
        y2="64"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FD853A" />
        <stop offset="1" stopColor="#FB6414" />
      </linearGradient>
    </defs>
  </svg>
);

export default TrulyInboxIcon;
